import React from "react";
import { Page } from "../components/general/Page";
import { HomeHeader } from "../components/home/HomeHeader";
import { HomeHighlights } from "../components/home/HomeHighlights";
import { HomePresentation } from "../components/home/HomePresentation";
import { HomeQuickLinks } from "../components/home/HomeQuickLinks";
import { useLanguage } from "../contexts";

const Home = () => {
  const { t } = useLanguage();
  return (
    <Page>
      <HomeHeader />
      <HomeHighlights />
      <HomePresentation
        title={t("HOME.OUR_STORY_TITLE")}
        description={t("HOME.STORY")}
        label={t("HOME.OUR_STORY")}
        image={require("../assets/images/home/story.JPG")}
        link="/about"
        linkText={t("HOME.LEARN_MORE")}
      />
      <HomePresentation
        label={t("HOME.OUR_PRODUCTS")}
        title={t("HOME.OUR_PRODUCTS_TITLE")}
        description={t("HOME.PRODUCTS")}
        image={require("../assets/images/home/products.JPG")}
        link="/products"
        linkText={t("HOME.LEARN_MORE")}
        isImageOnLeft
      />
      <HomePresentation
        label={t("HOME.OUR_SERVICES")}
        title={t("HOME.OUR_SERVICES_TITLE")}
        description={t("HOME.SERVICES")}
        image={require("../assets/images/home/service.JPG")}
        link="/contact"
        linkText={t("HOME.LEARN_MORE")}
      />
      <HomeQuickLinks />
    </Page>
  );
};

export default Home;
